<div class="{{localService.selectedLanguageCode}}" *ngIf="localService.languageContent">
  <app-popup-header [top]="10"></app-popup-header>
  <div class="modal-body" [ngStyle]="{'max-height' : maxBodyHeight + 'px'}">
    <app-language-container *ngIf="languageContents" [IsNeedNewLine]="true" [(languageContents)]="languageContents" (onEmptyLanguageContainerAdded)="onEmptyLanguageContainerAdded($event)" [IsLargeText]="true" [IsAllMandatory]="true" [IsShowAllLanguages]="true"></app-language-container>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="onPopupSave()">{{localService.languageContent.common.save}}</button>
  </div>
</div>
